import ko from "knockout";
import view from "./ko-inspector.html";
import { ICommand } from "flow/interfaces/ICommand";
import myFlowLocator from "flow/utils/myFlowLocator";
import config from "flow/config";

export interface IInspectorParams {
    dataContext?: any;
}

class InspectorViewModel {
    command: ICommand;
    constructor(private dataContext: any) {
        const myFlow = myFlowLocator.getMyFlow(this.dataContext);
        this.command = {
            click: () => {
                myFlow.showCustomDialog(config.componentIds.inspector, {
                    myFlow,
                    viewModel: this.dataContext
                });
            },
            text: "Inspector",
            icon: config.icons.eye
        };
    }
}

ko.components.register("ko-inspector", {
    viewModel: {
        createViewModel(params: IInspectorParams, componentInfo: KnockoutComponentTypes.ComponentInfo) {
            const dataContext =
                params.dataContext !== undefined ? ko.unwrap(params.dataContext) : ko.dataFor(componentInfo.element);
            return new InspectorViewModel(dataContext);
        }
    },
    template: view,
    synchronous: true
});
